import { normalizeBaseUrl } from "shared-utils";
import { Api as ProfileApi } from "../generated/ProfileApi";
import config from "../config";
import { createAxiosRequestInterceptors } from "../axios/axios-interceptors";

const profileApi = new ProfileApi({
  baseURL: normalizeBaseUrl(config.profileApiUrl),
});

createAxiosRequestInterceptors(profileApi.instance);

export default profileApi;
